import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from '../store';
import { User } from '@supabase/supabase-js';

export type AuthSliceType = {
  user: User | null;
  access_token: string | null;
  refresh_token: string | null;
  access_token_expire_at: number;
  refresh_token_expire_at: number;
  registerInfo: RegisterAPIRequest | null;
};

const initialState: AuthSliceType = {
  user: null,
  access_token: null,
  refresh_token: null,
  access_token_expire_at: 0,
  refresh_token_expire_at: 0,
  registerInfo: null
};

const slice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    setRegisterInfo(state: AuthSliceType, action: PayloadAction<RegisterAPIRequest | null>) {
      state.registerInfo = action.payload;
    },
    setUserInfo(state: AuthSliceType, action: PayloadAction<User | null>){
      state.user = action.payload;
    },
    updateUserKey(state: AuthSliceType, action: PayloadAction<{ [key: string]: any }>){
      if(state.user){
        state.user = { ...state.user, ...action.payload };
      }
    },
    logout(state: AuthSliceType, action: PayloadAction<{ removeUser?: boolean }>) {
      if(action.payload.removeUser) state.user = null;
    }
  },
});

export const {
  setUserInfo,
  setRegisterInfo,
  updateUserKey,
  logout
} = slice.actions;

export const selectAuth = createSelector(
  [(state: RootState) => state.auth],
  (state) => state
);

export default slice.reducer;
